import { exportToCSV, exportToPDF } from '../../../../utils/exportUtils';
import React, {useState, useRef} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Tooltip} from 'primereact/tooltip';
import {saveAs} from 'file-saver';
import apiClient from "../../../../services/api-client";
import {TieredMenu} from 'primereact/tieredmenu';
import AddNewRole from '../../../../features/admin/components/roles-management/AddNewRole';
import ViewRole from '../../../../features/admin/components/user-management/ViewRole.jsx'
import EditRole from '../../../../features/admin/components/user-management/EditRoles.jsx'
import {Dialog} from 'primereact/dialog';
import {ConfirmPopup, confirmPopup} from 'primereact/confirmpopup';
import {Toast} from 'primereact/toast';
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import {useMountEffect} from 'primereact/hooks';
import StorageHelper from '../../../../utils/storage-helper';
import AppCard from '../../../../components/ui/AppCard';


const RolesProfileReportTable = () => {
    const [Roles, setRoles] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [activeRole, setActiveRole] = useState(null)
    const dt = useRef(null);
    const toast = useRef(null);
    const [reloadData, setReloadData] = useState(false);
    const [viewRole, setViewRole] = useState(false)


    const cols = [
        {field: 'id', header: '#'},
        {field: 'name', header: 'Name'},
        {field: 'permissions.length', header: 'Permissions'},
        {field: 'actions', header: 'Actions'},
    ];

    useMountEffect(() => {
        fetchRoles();
    }, [reloadData]);


    const renderActions = (rowData) => {
        return (
            <div className="actions-container flex gap-2">
                <div className="tooltip" data-tip="View">
                    <button
                        className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
                        onClick={() => {
                            setReloadData(!reloadData);
                            setActiveRole(rowData);
                            setDialogVisible(!dialogVisible);
                            setViewRole(prevViewRole => !prevViewRole);
                        }}
                    >
                        <i className="pi pi-eye text-lg"></i>
                    </button>
                </div>
                <div className="tooltip" data-tip="Edit">
                    <button
                        className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
                        onClick={() => {
                            setReloadData(!reloadData);
                            setActiveRole(rowData);
                            setDialogVisible(!dialogVisible);
                        }}
                    >
                        <i className="pi pi-pencil text-lg"></i>
                    </button>
                </div>
            </div>
        );
    };

    const [dialogVisible, setDialogVisible] = useState(false);

    const exportColumns = cols.map((col) => ({title: col.header, dataKey: col.field}));

    const data = []


    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({selectionOnly});
    };

    const exportPdf = () => {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default();

                doc.autoTable(exportColumns, Roles);
                doc.save('doves-self-service-Roles-profiles-report.pdf');
            });
        });
    };


    const fetchRoles = async () => {
        try {
            await apiClient.get('system/roles', {
                headers: {
                    Authorization: 'Bearer ' + (StorageHelper.get('token'))
                }
            }).then((response) => {
                // //console.log(response);
                if (response.data.status === "SUCCESS") {
                    setRoles((response.data.responseBody));
                } else {
                    //console.log(response.data.status);
                }
            });

        } catch (error) {
            //console.log(error)
        }
    };

    const onGlobalFilter = (event) => {
        setGlobalFilter(event.target.value);
    };

    const globalFilterElement = (
        <div className="relative w-full max-w-xs">
            <i className="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-base-content/50"></i>
            <input
                type="text"
                className="input input-bordered w-full pl-10 h-10 shadow-sm bg-base-100 rounded-full"
                placeholder="Search..."
                value={globalFilter}
                onChange={onGlobalFilter}
            />
        </div>
    );

    const header = (
        <div className="flex flex-col sm:flex-row gap-4 justify-between items-center w-full">
            {globalFilterElement}
            <div className="flex items-center gap-3 ml-auto">
                <button className="btn btn-primary rounded-full btn-sm h-10"
                        onClick={() => setDialogVisible(!dialogVisible)}>
                    <i className="pi pi-user-plus"></i> Create New Role
                </button>

                <div className="dropdown dropdown-end">
                    <div tabIndex={0} role="button"
                         className="btn btn-outline btn-ghost h-10 min-h-0 shadow-sm rounded-full">
                        <i className="pi pi-file-export"></i> Export
                    </div>
                    <ul tabIndex={0} className="dropdown-content z-[99] menu p-2 shadow-sm bg-base-100 border border-base-200 rounded-box w-52 mt-2">
                                    <li><a onClick={() => exportToCSV(dt, 'User Roles')}><i className="pi pi-file-excel text-success"></i> Download CSV</a></li>
                                    <li><a onClick={() => exportToPDF(dt, 'User Roles', 'User Roles Report')}><i className="pi pi-file-pdf text-error"></i> Download PDF</a></li>
                                </ul>
                </div>
            </div>
        </div>
    );

    const handleCreateRole = async () => {
        setDialogVisible(false)

        await toast.current.show({severity: 'success', summary: 'Success', detail: 'User registered successfully'});

    }

    return (
        <div className="w-full">
            <AppCard title="User roles">

                <ConfirmPopup/>

                {activeRole === null ? (
                    <Dialog header="Register new user" visible={dialogVisible} maximizable style={{width: '30vw'}}
                            onHide={() => {
                                setActiveRole(null)
                                setDialogVisible(false)
                            }}>
                        <AddNewRole onCloseDialog={handleCreateRole} style={{marginTop: "20px;"}}/>
                    </Dialog>
                ) : (
                    <>
                        {
                            viewRole ?
                                <Dialog header="View role" visible={dialogVisible} maximizable style={{width: '50vw'}}
                                        onHide={() => {
                                            setActiveRole(null)
                                            setDialogVisible(false)
                                            setViewRole(prevViewRole => false)
                                        }}>
                                    <ViewRole roleData={activeRole} onCloseDialog={handleCreateRole}
                                              style={{marginTop: "20px;"}}/>
                                </Dialog>
                                :
                                <Dialog header="Edit role" visible={dialogVisible} maximizable style={{width: '30vw'}}
                                        onHide={() => {
                                            setActiveRole(null)
                                            setDialogVisible(false)
                                        }}>
                                    <EditRole roleData={activeRole} onCloseDialog={handleCreateRole}
                                              style={{marginTop: "20px;"}}/>
                                </Dialog>
                        }
                    </>
                )
                }

                <DataTable
                    header={header}
                    paginatorTemplate="CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"

                    paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                    ref={dt}
                    value={Roles}
                    tableStyle={{minWidth: '50rem'}}
                    globalFilter={globalFilter}
                    emptyMessage="No Roles found"
                >
                    {cols.map((col, index) => {
                        if (col.field === 'actions') {
                            return (
                                <Column
                                    key={index}
                                    body={renderActions}
                                    header={col.header}
                                />
                            );
                        }
                        return (
                            <Column key={index} field={col.field} header={col.header}/>
                        );
                    })}
                </DataTable>
            </AppCard>
        </div>
    );
};

export default RolesProfileReportTable;
